import { FeedbackDialogModule } from './feedback-dialog/feedback-dialog.module';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@app/theme/button/button.module';
import { CardModule } from '@app/theme/card/card.module';
import { ErrorMessageModule } from '@app/theme/error-message/error-message.module';
import { SelectModule } from '@app/theme/select/select.module';
import { TextFieldModule } from '@app/theme/text-field/text-field.module';
import { WizardFormModule } from '@app/theme/wizard-form/wizard-form.module';
import { NavModule } from '@app/theme/nav/nav.module';
import { BreadcrumbModule } from '@app/theme/breadcrumb/breadcrumb.module';
import { TextAreaModule } from '@app/theme/text-area/text-area.module';
import { FileUploadModule } from '@app/theme/file-upload/file-upload.module';
import { TabModule } from '@app/theme/tab/tab.module';
import { MenuModule } from '@app/theme/menu/menu.module';
import { SideNavModule } from '@app/theme/side-nav/side-nav.module';
import { EmptyModule } from './empty/empty.module';
import { MatSpinnerButtonModule } from './mat-spinner-button/mat-spinner-button.module';
import { PaginatorModule } from './paginator/paginator.module';
import { LoadingSpinnerModule } from './loading-spinner/loading-spinner.module';
import { PageHeroSignatureModule } from './page-hero-signature/page-hero-signature.module';
import { DialogModule } from './dialog/dialog.module';
import { TooltipModule } from './tooltip/tooltip.module';

@NgModule({
  exports: [
    ButtonModule,
    CardModule,
    ErrorMessageModule,
    SelectModule,
    TextFieldModule,
    WizardFormModule,
    ErrorMessageModule,
    NavModule,
    BreadcrumbModule,
    TextAreaModule,
    FileUploadModule,
    TabModule,
    SideNavModule,
    MenuModule,
    EmptyModule,
    MatSpinnerButtonModule,
    PaginatorModule,
    LoadingSpinnerModule,
    PageHeroSignatureModule,
    DialogModule,
    TooltipModule,
    FeedbackDialogModule,
  ],
  imports: [],
})
export class ThemeModule {}
